import { defineMessages } from 'react-intl';

export const SelectMessages = defineMessages({
  accessibilityPlaceholder: {
    id: 'app.Select.accessibilityPlaceholder',
  },
  manufacturerPlaceholder: {
    id: 'app.Select.manufacturerPlaceholder',
    defaultMessage: 'Vyber výrobce měřidla',
  },
  meterModelPlaceholder: {
    id: 'app.Select.meterModelPlaceholder',
    defaultMessage: 'Vyber model měřidla',
  },
  meterModelFamilyHint: {
    id: 'app.Select.meterModelFamilyHint',
    defaultMessage:
      'Zahrnuje modely celé rodiny výrobců: {manufacturers}. Výběrem modelu jiného výrobce se výrobce přepne na něj.',
  },
  measurementTypeSelect: {
    id: 'app.Select.measurementTypePlaceholder',
    defaultMessage: 'Vyber typ měření',
  },
  measurementCategoryPlaceholder: {
    id: 'app.Select.measurementCategoryPlaceholder',
    defaultMessage: 'Vyber kategorii měření',
  },
  meterOwnerPlaceholder: {
    id: 'app.common.meterOwnerPlaceholder',
    defaultMessage: 'Napiš majitele měřidla',
  },
  suggested: {
    id: 'app.Select.suggested',
    defaultMessage: 'Doporučené',
  },
  base: {
    id: 'app.Select.base',
    defaultMessage: 'Výchozí',
  },
  meterAddonOutputPlaceholder: {
    id: 'app.Select.meterAddonOutputPlaceholder',
  },
  commodityPlaceholder: {
    id: 'app.common.commodityPlaceholder',
  },
});
